import { Injectable } from '@angular/core';
import { EventRow } from 'app/logger/logger.event-row';
import { MetricRow } from 'app/logger/logger.metric-row';
import { ILogger } from 'app/logger/ILogger';
import { convertObjectToString } from 'app/shared/utils/string.util';
import { Subject } from 'rxjs';
import { type IModelChanged } from 'app/logger/logger.service';

@Injectable()
export class CmdApiLoggerService implements ILogger {

    // noop Subject aligning with context level LoggerService
    public readonly modelChanged$: Subject<IModelChanged[]> = new Subject<IModelChanged[]>();

    private static readonly defaultColor: string = '\x1b[0m';
    private static readonly red: string = '\x1b[31m';
    private static readonly yellow: string = '\x1b[33m';
    private static readonly cyan: string = '\x1b[46m';

    public initializeLoggingContext(): void {
        // nothing
    }

    public log(componentName: string, message: string): void {
        this._print(CmdApiLoggerService.defaultColor, `${componentName}: ${message}`);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public error(componentName: string, message: any): void {
        this._print(CmdApiLoggerService.red, `ERROR === ${componentName}: ${message}`);
    }

    public warn(componentName: string, message: string): void {
        this._print(CmdApiLoggerService.yellow, `WARNING === ${componentName}: ${message}`);
    }

    public logEvent(event: EventRow): void {
        // Do not log events for now...
        // this._print(CmdApiLoggerService.defaultColor, `${convertObjectToString(event)}`);
    }

    public logMetric(metric: MetricRow): void {
        this._print(CmdApiLoggerService.defaultColor, `${convertObjectToString(metric)}`);
    }

    public logPageView(): void {
        // nothing
    }

    public flush(): void {
        // do nothing
    }

    public debug(componentName: string, message: string): void {
        this._print(CmdApiLoggerService.cyan, `${componentName}: ${message}`);
    }

    private _print(color: string, message: string): void {
        // eslint-disable-next-line no-console
        console.log(color, message);
    }
}
